export default "__VITE_ASSET__DjjNB1ah__"